<template>
  <div class="container">
    <div class="swiper-box">
      <van-swipe
        class="sb_swiper"
        autoplay="true"
        :interval="interval"
        :duration="duration"
        :show-indicators="false"
        @change="bannerChange"
      >
        <van-swipe-item
          v-for="(item, index) in bannerList"
          :key="index"
          class="banItem"
        >
          <van-image :src="item.Img" fit="contain" class="banImg"></van-image>
        </van-swipe-item>
      </van-swipe>
      <!--重置小圆点的样式 -->
      <div class="dots">
        <div v-for="(item, index) in bannerList" :key="index">
          <div class="dot" :class="index == current ? 'active' : ''"></div>
        </div>
      </div>
    </div>
    <div class="tab-box">
      <div class="tb_item" @click="toPathHandle">
        <div><span class="iconfont icon-shenbao"></span></div>
        <span>我要申报</span>
      </div>
      <router-link class="tb_item" to="/previous">
        <div><span class="iconfont icon-bangdan"></span></div>
        <span>历届获奖</span>
      </router-link>
      <router-link class="tb_item" to="/judges">
        <div><span class="iconfont icon-tuijian"></span></div>
        <span>推荐&评委</span>
      </router-link>
      <router-link class="tb_item" to="/setting">
        <div><span class="iconfont icon-award"></span></div>
        <span>奖项设置</span>
      </router-link>
    </div>
    <!-- 产品1 技术奖2 工程3 设计4 雅江5 百强企业6 出口企业7 -->
    <div class="award-box">
      <div class="title">照明类奖项</div>
      <div class="ab_horizontal">
        <router-link
          class="abh_item"
          :to="{ name: 'project', query: { id: 1 } }"
        >
          <span class="iconfont icon-cpj"></span>
          <div>
            <div>产品奖</div>
            <span>Product Award</span>
          </div>
        </router-link>
        <router-link
          class="abh_item"
          :to="{ name: 'project', query: { id: 4 } }"
        >
          <span class="iconfont icon-jsj"></span>
          <div>
            <div>设计奖</div>
            <span>Design Award</span>
          </div>
        </router-link>
        <router-link
          class="abh_item"
          :to="{ name: 'project', query: { id: 3 } }"
        >
          <span class="iconfont icon-gcj"></span>
          <div>
            <div>工程奖</div>
            <span>Project Award</span>
          </div>
        </router-link>
        <router-link
          class="abh_item"
          :to="{ name: 'project', query: { id: 4 } }"
        >
          <span class="iconfont icon-rhj"></span>
          <div>
            <div>创新融合奖</div>
            <span>Innovation Award</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="award-box">
      <div class="title">数智类奖项</div>
      <div class="ab_vertical">
        <router-link
          class="abv_item"
          :to="{ name: 'project', query: { id: 11 } }"
        >
          <div><span class="iconfont icon-xinpian"></span></div>
          <div>数智成果奖</div>
          <span>Digital Intelligence Achievement Award</span>
        </router-link>
        <router-link
          class="abv_item"
          :to="{ name: 'project', query: { id: 12 } }"
        >
          <div><span class="iconfont icon-fenxi"></span></div>
          <div>数智设计奖</div>
          <span>Digital Intelligence Design Award</span>
        </router-link>        
      </div>
    </div>
    <div class="module-box">
      <div class="title">关于神灯奖</div>
      <div class="mb_about">
        <div class="mba_left">
          <div class="mba_title">追光十年，共启未来</div>
          <div>
            今年，阿拉丁神灯奖创办十周年。这十年来，阿拉丁神灯奖见证了6031个品牌的崛起与成长，收录了13067项创新产品、技术和工程。
          </div>
          <div class="mb_button">
            <router-link to="/about">查看详情</router-link>
          </div>
        </div>
        <img src="../../../static/images/lighting/pwb.png" fit="contain" />
      </div>
    </div>
    <div class="module-box" style="padding-right: 0px">
      <div class="title">
        宣传推广<router-link
          to="/promotion"
          class="more"
          v-if="propagateList.length >= 5"
          >更多</router-link
        >
      </div>
      <div class="mb_propaganda">
        <div
          class="mbp_item"
          v-for="(item, index) in propagateList"
          :key="index"
          @click.stop="toDetailHandle(item.Url)"
        >
          <van-image :src="item.ImgUrl" fit="cover" radius="5" />
          <div class="overFlowTwo">{{ item.Title }}</div>
        </div>
      </div>
    </div>
    <div class="module-box">
      <div class="title" style="margin-bottom: 15rpx">新闻动态</div>
      <div
        v-for="(item, index) in newsList"
        :key="index"
        @click.stop="toNew(item.Url)"
      >
        <div class="mb_news">
          <div class="mbn_title">{{ item.Title }}</div>
          <div class="overFlowTwo" v-if="item.Summary">
            {{ item.Summary }}
          </div>
          <div>
            <span class="iconfont icon-time"></span> {{ item.CreateTime }}
          </div>
        </div>
      </div>
      <div class="mb_button news">
        <router-link to="/newslist">更多新闻动态</router-link>
      </div>
    </div>
    <div class="module-box">
      <div class="title">合作伙伴</div>
      <div class="mbcoo_title" style="margin-top: 45rpx">主办单位</div>
      <div class="mbcoo_list">
        <img src="../../../static/images/lighting/gy.png" />
        <img src="../../../static/images/lighting/flkf.png" />
        <img src="../../../static/images/lighting/yjy.png" />
      </div>
      <div class="mbcoo_title">承办单位</div>
      <div class="mbcoo_list">
        <img src="../../../static/images/lighting/ald.png" />
      </div>
      <div class="mbcoo_title">创新融合奖—雅江创意照明奖 联合主办单位</div>
      <div class="mbcoo_list">
        <img src="../../../static/images/lighting/yj.png" />
      </div>
      <div class="mbcoo_title">
        创新融合奖—照明细分领域出口企业50强 联合主办单位
      </div>
      <div class="mbcoo_list">
        <img src="../../../static/images/lighting/hdl.png" />
      </div>
      <div class="mbcoo_title">创新融合奖—智能照明生态百强榜 冠名单位</div>
      <div class="mbcoo_list">
        <img src="../../../static/images/lighting/hd.png" />
      </div>
    </div>
    <div class="panel-box">
      <van-collapse v-model="activeNames" @change="onChange" :border="false">
        <van-collapse-item title="主办官方" name="主办官方" :border="false">
          <div>邮箱 E-mail：award@alighting.cn</div>
          <div>电话 Tel：18902263657</div>
          <div>传真 Fax：020-85272455</div>
          <div>地址 Address：广州市天河区智慧城天慧路18号</div>
        </van-collapse-item>
        <van-collapse-item title="申报咨询" name="申报咨询" :border="false">
          <div>联系人 Contact：何小姐</div>
          <div>邮箱 E-mail：hqs@alighting.cn</div>
          <div>电话 Tel：18902263629</div>
          <div>传真 Fax：020-8527 2455</div>
        </van-collapse-item>
        <van-collapse-item title="媒体合作" name="媒体合作" :border="false">
          <div>联系人 Contact：黄小姐</div>
          <div>邮箱 E-mail：hyy@alighting.cn</div>
          <div>电话 Tel：1580001 2552</div>
          <div>传真 Fax：020-8527 2455</div>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>
<script>
import { formatTimeDay } from "@/utils/date";
import { mobileAdverts } from "@/api/index";
import { propagateList, newsContentList } from "@/api/lighting";
import { Collapse, Swipe, SwipeItem, Image, CollapseItem } from "vant";
export default {
  name: "lightingIndex",
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-collapse": Collapse,
    "van-collapse-item": CollapseItem,
    "van-image": Image,
  },
  data() {
    return {
      interval: 3000,
      duration: 500,
      current: 0,
      bannerList: [], // 轮播图参数

      propagateList: [], //推广活动
      newsList: [], //新闻动态
      activeNames: ["主办官方"],
    };
  },
  methods: {
    //轮播切换
    bannerChange(index) {
      this.current = index;
    },

    onChange(event) {
      this.activeNames = event;
    },

    //获取banner
    getBannerList() {
      var that = this;
      var data = {
        Type: 327,
      };
      mobileAdverts(data).then((res) => {
        that.bannerList = res.Data.List;
      });
    },

    //我要申报
    toPathHandle() {
      window.location.href =
        "https://www.alighting.cn/webapp/award/declare.htm?t=1&timestamp=1650508242";
    },

    //获取宣传
    getPropagateList() {
      var that = this;
      var data = {
        Page: {
          PageSize: 5,
          PageIndex: 1,
        },
        AwardYear: that.awardYear,
        CategoryId: 0,
      };
      propagateList(data).then((res) => {
        that.propagateList = res.Data.List;
      });
    },

    //宣传跳转
    toDetailHandle(href) {
      window.location.href = href;
    },

    //获取新闻
    getNewsList() {
      var that = this;
      var data = {
        Page: {
          PageSize: 3,
          PageIndex: 1,
        },
        AwardYear: that.awardYear,
      };
      newsContentList(data).then((res) => {
        res.Data.List.forEach((item, index) => {
          item.CreateTime = formatTimeDay(item.CreateTime, ".");
        });
        that.newsList = res.Data.List;
      });
    },

    //新闻跳转
    toNew(href) {
      window.location.href = href;
    },
  },

  mounted() {
    if (this.Common._isMobile()) {
      this.getBannerList();
      this.getPropagateList();
      this.getNewsList();
    } else {
      window.location.href = "https://sdj.alighting.com/";
    }
  },
};
</script>
<style scoped src="../../../static/css/lightingIndex.css">
</style>